








import { Component } from "vue-property-decorator";

import LanguageSelection from "../components/LanguageSelection.vue";
import ViewBase from "../views/ViewBase";

@Component({
  components: { LanguageSelection }
})
export default class Home extends ViewBase {
  protected get title() {
    return "/";
  }
}
